import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-remark-dialog",
  templateUrl: "./remark-dialog.component.html",
  styleUrls: ["./remark-dialog.component.scss"]
})
export class ConfirmRemarkComponent implements OnInit {
  public remarkValue: any = "";
  constructor(
    public dialogRef: MatDialogRef<ConfirmRemarkComponent>
  ) {}

  ngOnInit() {}

  SaveRemarks(value) {
    let data = { confirm: value, remark: this.remarkValue };
    this.dialogRef.close(data);
  }

  onNoClick() {
    let data = { confirm: "No", remark: "" };
    this.dialogRef.close(data);
  }
}
